import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField';
import _ from 'lodash'
import {reduxForm, formValueSelector} from 'redux-form'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import DefaultCheckbox from '@material-ui/core/Checkbox';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import * as globalActions from '../../global/reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Number from '../../../../../uis/form/number';
import Select from '../../../../../uis/form/select'
import dateFormat from '../../../../../util/dateFormat'
import * as http from '../../../../../util/http'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    table: {
        minWidth: 700,
    },
    dialog: {
        maxWidth: 900
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit * 2
    },
    doubleTextField: {
        width: (300 * 2) + (theme.spacing.unit * 4),
        margin: theme.spacing.unit * 2
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    tableCell: {
        padding: '4px 28px 4px 12px'
    },
    more: {
        display: 'inline-block',
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    showMe: {
        marginLeft: theme.spacing.unit * 2
    }
})

let allSetting;
const validate = values => {
    const errors = {}
    
    if (!values.aliwangwang) {
        errors.aliwangwang = '必填'
    }
    
    if (!values.orderId) {
        errors.orderId = '必填'
    }
    if (values.customerPhone && values.customerPhone.length !== 11) {
        errors.customerPhone = '格式不正确';
    }

    if (!values.invoiceName) {
        errors.invoiceName = '必填'
    }

    if (!values.invoiceType) {
        errors.invoiceType = '必填'
    }

    if (values.invoiceType === '公司' && !values.invoiceNum) {
        errors.invoiceNum = '公司必填，个人、政府非企业选填'
    }

    if (values.invoiceType === '公司' && values.invoiceNum) {
        const invoiceNum = values.invoiceNum.replace(/\s/g, '').length;
        if (invoiceNum !== 18 && invoiceNum !== 15) {
            errors.invoiceNum = '为XX位（正常是15或者18位），请进入查询网站www.tianyancha.com，查询核实后再提交'
        }
    }


    if (values.invoiceNum && values.invoiceNum.toUpperCase().indexOf('O') !== -1) {
        errors.invoiceNum = '税号不能包含字母o、O';
    }

    if (values.invoiceMoney === undefined) {
        errors.invoiceMoney = '必填'
    } else {
        if (values.companyAbbr) {
            if (values.invoiceMoney < +allSetting[`${values.companyAbbr}_min`]) {
                errors.invoiceMoney = `开票金额小于最低开票金额${+allSetting[`${values.companyAbbr}_min`]}`
            } else if (values.invoiceMoney > +allSetting[`${values.companyAbbr}_max`]) {
                errors.invoiceMoney = `开票金额大于最高开票金额${+allSetting[`${values.companyAbbr}_max`]}`
            }
        }
    }
    
    // if (values.companyAbbr === 'taozhi') {
    //     if (values.invoiceMoney < 300) {
    //         errors.invoiceMoney = '用淘知公司开票时，金额需要大于等于300'
    //     }
    // }
    // if (!values.customerPhone) {
    //     errors.customerPhone = '必填'
    // }
    
    if (!values.customerEmail) {
        errors.customerEmail = '必填'
    }
    if (values.customerEmail && !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(values.customerEmail)) {
        errors.customerEmail = '格式不正确';
    }
    return errors
}

function getCompanys() {
    if (http.isSuixiRole()) {
        return [{"name":"遂溪牛标文化传播有限公司","value":"suixi"}];
    }
    if (http.isHeishiRole()) {
        return [{"name":"湛江黑石科技有限公司","value":"heishi"}, {"name":"湛江淘知科技有限公司","value":"taozhi"}]
    }
    if (http.isDouquRole()) {
        return [{"name":"广州都去网络技术有限公司","value":"douqu"}]
    }
    if (http.isFPGroupRole()) {
        return [{"name":"遂溪牛标文化传播有限公司","value":"suixi"}, {"name":"湛江黑石科技有限公司","value":"heishi"},{"name":"广州都去网络技术有限公司","value":"douqu"}, {"name":"湛江淘知科技有限公司","value":"taozhi"}];
    }
    return [];
}
function getCompanyAbbr() {
    if (http.isSuixiRole()) {
        return 'suixi';
    }
    if (http.isHeishiRole()) {
        return 'heishi';
    }
    if (http.isDouquRole()) {
        return 'douqu';
    }
    if (http.isTaozhiRole()) {
        return 'taozhi';
    }
}

class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, invoiceType} = this.props
        
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth="md"
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <div>
                        税号查询网址: <a href="http://www.tianyancha.com" target="_blank" rel="noopener noreferrer">www.tianyancha.com</a>
                    </div>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        <Text name="orderId" label="订单号" placeholder="请输入订单号" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Text name="invoiceName" label="发票抬头" placeholder="请输入发票抬头" className={classes.textField} required={true}/>
                        <Text name="invoiceNum" label="税号" placeholder="请输入税号" className={classes.textField} required={invoiceType === '公司'}/>
                    </div>
                    <div>
                        <Text name="customerAddress" label="购货单位地址、电话" placeholder="请输入购货单位地址、电话" className={classes.textField} required={false}/>
                        <Text name="customerBank" label="购货单位开户行、账号" placeholder="请输入购货单位开户行、账号" className={classes.textField} required={false}/>
                    </div>
                    <div>
                        <Number name="invoiceMoney" label="开票金额" placeholder="请输入开票金额" className={classes.textField} required={true}/>
                        <Select name="invoiceType" label="开票类型" placeholder="请输入开票类型" className={classes.textField} required={true} data={[{"name":"公司","value":"公司"},{"name":"其他","value":"其他"}]}/>
                    </div>
                    <div>
                        <Text name="customerPhone" label="联系电话" placeholder="请输入联系电话" className={classes.textField} required={false}/>
                        <Text name="customerEmail" label="联系邮箱" placeholder="请输入联系邮箱" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Select name="productType" label="产品类型" placeholder="请输入产品类型" className={classes.textField} required={true} data={[{"name":"配音费","value":"配音费"},{"name":"网站建设","value":"网站建设"}]}/>
                        <Select name="companyAbbr" label="公司" placeholder="请输入公司" className={classes.textField} required={false} data={getCompanys()}/>
                    </div>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, invoiceType} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
            maxWidth="md"
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <div>
                        <Text name="aliwangwang" label="客户旺旺号" placeholder="请输入客户旺旺号" className={classes.textField} required={true}/>
                        <Text name="orderId" label="订单号" placeholder="请输入订单号" className={classes.textField} required={true}/>
                    </div>
                    <div>
                        <Text name="invoiceName" label="发票抬头" placeholder="请输入发票抬头" className={classes.textField} required={true}/>
                        <Text name="invoiceNum" label="税号" placeholder="请输入税号" className={classes.textField} required={invoiceType === '公司'}/>
                    </div>
                    <div>
                        
                    </div>
                    <div>
                        <Text name="customerAddress" label="购货单位地址、电话" placeholder="请输入购货单位地址、电话" className={classes.textField} required={false}/>
                        <Text name="customerBank" label="购货单位开户行、账号" placeholder="请输入购货单位开户行、账号" className={classes.textField} required={false}/>
                    </div>
                    <div>
                        <Number name="invoiceMoney" label="开票金额" placeholder="请输入开票金额" className={classes.textField} required={true}/>
                        <Select name="invoiceType" label="开票类型" placeholder="请输入开票类型" className={classes.textField} required={true} data={[{"name":"公司","value":"公司"},{"name":"其他","value":"其他"}]}/>
                    </div>
                    <div>
                        <Text name="customerPhone" label="联系电话" placeholder="请输入联系电话" className={classes.textField} required={true}/>
                        <Text name="customerEmail" label="联系邮箱" placeholder="请输入联系邮箱" className={classes.textField} required={true}/>
                    </div>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

class HongChongDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.hongchong}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>警告：请确认此订单已经退款或者客户要更换开票信息，红冲后要告知客户，发票已经作废，不能用作报销，申请后联系组长审核</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.hongchong(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

class ShHongChongDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.shhongchong}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>是否确定通过红冲审核？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.bhhongchong(showModal.id))}>驳回</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.shhongchong(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        const selector = formValueSelector('invoiceAddForm')
        return {
            initialValues: {
                invoiceType: '公司',
                productType: '配音费',
                companyAbbr: getCompanyAbbr()
            },
            invoiceType: selector(state, 'invoiceType')
        }
    },
)(reduxForm({
    form: 'invoiceAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => {
        const selector = formValueSelector('invoiceUpdateForm')
        return {
            initialValues: state.invoice.detail,
            invoiceType: selector(state, 'invoiceType')
        }
    },
  )(reduxForm({
    form: 'invoiceUpdateForm',
    validate
})(UpdateDialog))

class Invoice extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getStatusDetail())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target ? e.target.value : e})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal, statusDeatial, allSetting} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['发票管理_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                        <FormControlLabel
                            control={
                                <DefaultCheckbox
                                    checked={query.isOnlyShowMe}
                                    onChange={(e) => {
                                        this.changeQuery(!query.isOnlyShowMe, 'isOnlyShowMe');
                                        dispatch(actions.getStatusDetail())
                                    }}
                                    value={query.isOnlyShowMe}
                                />
                            }
                            className={classes.showMe}
                            label={"只显示我提交的"}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                hideCancelBtn={item.hideCancelBtn}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="status"
                            className={classes.group}
                            value={query.status}
                            onChange={(e) => this.changeQuery(e,'status')}
                        >
                            <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{statusDeatial['全部'] || 0}）</span></p>} />
                            {statusDeatial['新增'] && <FormControlLabel value="新增" control={<Radio />} label={<p>新增<span style={{color: 'red'}}>（{statusDeatial['新增']}）</span></p>} />}
                            {statusDeatial['开票中'] && <FormControlLabel value="开票中" control={<Radio />} label={<p>开票中<span style={{color: 'red'}}>（{statusDeatial['开票中']}）</span></p>} />}
                            {statusDeatial['等待下载发票'] && <FormControlLabel value="等待下载发票" control={<Radio />} label={<p>等待下载发票<span style={{color: 'red'}}>（{statusDeatial['等待下载发票']}）</span></p>} />}
                            {statusDeatial['下载发票中'] && <FormControlLabel value="下载发票中" control={<Radio />} label={<p>下载发票中<span style={{color: 'red'}}>（{statusDeatial['下载发票中']}）</span></p>} />}
                            {statusDeatial['完成'] && <FormControlLabel value="完成" control={<Radio />} label={<p>完成<span style={{color: 'red'}}>（{statusDeatial['完成']}）</span></p>} />}
                            {statusDeatial['红冲发票审核'] && <FormControlLabel value="红冲发票审核" control={<Radio />} label={<p>红冲发票审核<span style={{color: 'red'}}>（{statusDeatial['红冲发票审核']}）</span></p>} />}
                            {statusDeatial['等待红冲发票'] && <FormControlLabel value="等待红冲发票" control={<Radio />} label={<p>等待红冲发票<span style={{color: 'red'}}>（{statusDeatial['等待红冲发票']}）</span></p>} />}
                            {statusDeatial['红冲发票中'] && <FormControlLabel value="红冲发票中" control={<Radio />} label={<p>红冲发票中<span style={{color: 'red'}}>（{statusDeatial['红冲发票中']}）</span></p>} />}
                            {statusDeatial['红冲完成'] && <FormControlLabel value="红冲完成" control={<Radio />} label={<p>红冲完成<span style={{color: 'red'}}>（{statusDeatial['红冲完成']}）</span></p>} />}
                            {statusDeatial['错误'] && <FormControlLabel value="错误" control={<Radio />} label={<p>错误<span style={{color: 'red'}}>（{statusDeatial['错误']}）</span></p>} />}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {http.isFPGroupRole() && <Grid container spacing={8}>
                    {['淘知发票开关', '遂溪发票开关', '都去发票开关', '黑石发票开关'].map(name => {
                        return <FormControlLabel
                            control={
                                <Switch
                                    checked={+allSetting[name] === 1}
                                    onChange={()=>dispatch(globalActions.modify(name, +allSetting[name] === 1 ? '0' : '1'))}
                                    value={allSetting[name]}
                                />
                            }
                            label={name}
                        />
                    })}
                </Grid>}
                {http.isFPGroupRole() && <Grid container spacing={8}>
                    {['taozhi', 'suixi', 'douqu', 'heishi'].map(name => {
                        const dict = {
                            'taozhi': "淘知",
                            'suixi': "遂溪",
                            'douqu': "都去",
                            'heishi': "黑石",
                        }
                        return <div>
                            <label>{dict[name]}：</label>
                            <TextField
                                type={"number"}
                                placeholder={'最小值'}
                                margin="normal"
                                value={+allSetting[`${name}_min`]}
                                style={{marginLeft: 20}}
                                onChange={(e)=>dispatch(globalActions.modify(`${name}_min`, e.target.value))}
                            />
                             - 
                            <TextField
                                type={"number"}
                                placeholder={'最大值'}
                                margin="normal"
                                value={+allSetting[`${name}_max`]}
                                style={{marginLeft: 20}}
                                onChange={(e)=>dispatch(globalActions.modify(`${name}_max`, e.target.value))}
                            />
                        </div>
                    })}
                </Grid>}
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableCell}>旺旺号</TableCell>
                                <TableCell className={classes.tableCell}>订单号</TableCell>
                                <TableCell className={classes.tableCell}>发票抬头</TableCell>
                                <TableCell className={classes.tableCell}>开票金额</TableCell>
                                <TableCell className={classes.tableCell}>单位信息</TableCell>
                                <TableCell className={classes.tableCell}>状态</TableCell>
                                <TableCell>操作</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>
                                            <p>旺旺号: {row.aliwangwang}</p>
                                            <p>邮箱: {row.customerEmail}</p>
                                            <p>电话: {row.customerPhone}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.orderId}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.invoiceName}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {row.invoiceMoney}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>税号: {row.invoiceNum}</p>
                                            <p>购货单位地址、电话: {row.customerAddress}</p>
                                            <p>购货单位开户行、账号: {row.customerBank}</p>
                                            <p>产品类型: {row.productType}</p>
                                            <p>公司: {(_.find(getCompanys(), {value: row.companyAbbr}) || {}).name}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <p>状态: {row.status}{row.status === '错误' ? <a href={`javascript:;`} onClick={()=>dispatch(actions.update({...row, status: '下载发票中'}))} style={{paddingLeft: 10, }}>重新提取状态</a> : ''}</p>
                                            {row.status === '错误' && <p>状态: {row.statusMessage}</p>}
                                            {row.invoiceUrl && <p>发票链接: <a href={row.invoiceUrl} target="_blank">下载</a></p>}
                                            {row.status === '完成' && permissionMap['发票管理_作废红冲'] ? <p>作废红冲: <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'hongchong', id: row.id})} style={{paddingLeft: 10, }}>红冲</a></p> : ''}
                                            {row.status === '红冲发票审核' && permissionMap['发票管理_红冲审核'] ? <p>审核红冲: <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'shhongchong', id: row.id})} style={{paddingLeft: 10, }}>红冲</a></p> : ''}
                                            <p>创建时间: {dateFormat(new Date(row.createTime))}</p>
                                            <p>最后操作时间: {dateFormat(new Date(row.updateTime))}</p>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {permissionMap['发票管理_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(row.id, false))}>修改</a>}<br/><br/>
                                            {permissionMap['发票管理_删除'] && <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}>删除</a>}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
                {showModal.hongchong && <HongChongDialog {...this.props} />}
                {showModal.shhongchong && <ShHongChongDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    allSetting = state.global.allSetting
    return {
        ...state.invoice,
        permissionMap: state.auth.user.permissionMap,
        allSetting
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Invoice))


// WEBPACK FOOTER //
// ./src/pages/home/routes/invoice/components/list.js